import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import Title from "@streeteasy/design-system/deprecated/Title";

export const ClaimYourHomeIcon = styled.img`
  width: 30px;
`;

export const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
`;

export const Heading = styled(Title).attrs({
  as: "h6",
  type: "secondaryLg"
})`
  display: inline-block;
  margin: 0 10px;
`;

export const Separator = styled.hr`
  background-color: ${colors.rabbitGrey};
  margin: 10px 0 0;
`;
